import { render, staticRenderFns } from "./VotingOption.vue?vue&type=template&id=67446784&scoped=true"
import script from "./VotingOption.vue?vue&type=script&lang=js"
export * from "./VotingOption.vue?vue&type=script&lang=js"
import style0 from "./VotingOption.vue?vue&type=style&index=0&id=67446784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67446784",
  null
  
)

export default component.exports